import React, { useState, useEffect } from 'react'
import { Text } from '@chakra-ui/react'

import Bookmark from '../../components/Bookmark/Bookmark'
import Topics from '../../components/Topics/Topics'

import items from './data.js'

// const allTopics = ['all', ...new Set(items.map((item) => item.topic))]

function Bookmarks() {
  const [bookmarkItems, setBookmarkItems] = useState(items)
  const [topics, setTopics] = useState(['all'])

  const filterItems = (topics) => {
    // const newItems = items.filter((item) => {
    //   return item.topics.some((r) => topics.includes(r))
    // })
    if (topics === 'all') {
      setBookmarkItems(items)
      return
    }
    const newItems = items.filter((item) => item.topics === topics)
    setBookmarkItems(newItems)
  }

  return (
    <div className="content">
      <Text>Bookmarks</Text>
      <Text>
        Pages worth sharing. I store all of these personally, may as well share.
      </Text>
      <Topics filterItems={filterItems} topics={topics} />
      <Bookmark items={bookmarkItems} />
    </div>
  )
}

export default Bookmarks
